/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsloaderror2Inputs */

const en_earningsloaderror2 = /** @type {(inputs: Earningsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your earnings couldn't be loaded.`)
};

const de_earningsloaderror2 = /** @type {(inputs: Earningsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Einnahmen konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Your earnings couldn't be loaded." |
*
* @param {Earningsloaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsloaderror2 = /** @type {((inputs?: Earningsloaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsloaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsloaderror2(inputs)
	return de_earningsloaderror2(inputs)
});
export { earningsloaderror2 as "earningsLoadError" }